import { z } from 'zod';

import { TextItem } from './common';

export const CopingStrategy = TextItem;
export type CopingStrategy = z.infer<typeof CopingStrategy>;

export const CopingStrategies = z.array(CopingStrategy).default([]);
export type CopingStrategies = z.infer<typeof CopingStrategies>;
